// third-party
import { combineReducers } from 'redux';

// project import
import menu from './menu';
import snackbar from './snackbar';
import reservation from './reservation';
import users from './users';
import auth from './auth';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  menu,
  users,
  auth,
  snackbar,
  reservation
});

export default reducers;
